export default "__VITE_ASSET__DgKD29_q__"